import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

const beGetTimeOffAllowancesForStylist = actionBe('beGetTimeOffAllowancesForStylist', ({ AT, ATAG, stylistId }) =>
  endpoint(H.get, 'salon/v2/:salonId/time_off_allowances/?stylist_id=:stylistId', {
    AT,
    name: ATAG,
    params: { stylistId },
  }),
);

// noinspection JSUnusedGlobalSymbols
export default beGetTimeOffAllowancesForStylist;
